import React, {useEffect, useState} from 'react';
import {Card, CardHeader, Modal, Row, Table} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {alert_strings} from "../translations/alert_translations";
import {common_strings} from "../translations/common_translations";
import localeHelpers from "../helpers/LocaleHelper";
import {resource_strings} from "../translations/resource_translations";
import Badge from "reactstrap/es/Badge";
import FeedbackItem from "./Lists/FeedbackItem";
import FeedbackItemRow from "./Lists/FeedbackItemRow";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const FeedbackComponent = (props) => {
    const [visible, setVisible] = useState(props.showFeedback === true);
    const [feedbacks, setFeedbacks] = useState(props.feedbacks);
    const [isInfoExpanded, setIsInfoExpanded] = useState(props.expandInfo);

    const onDismiss = () => setVisible(false);

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    };

    localize();

    useEffect(() => {
        if (props.showFeedback !== visible) {
            setVisible(props.showFeedback === true)
        }
    });

    function toggle() {
        props.toggleFeedback();
    }

    return (
        <Modal
            className="modal-dialog-centered modal-secondary"
            size="lg"
            isOpen={visible}
            toggle={() => toggle()}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => toggle()}
                >
                    <span aria-hidden={true} style={{color: 'gray'}}>×</span>
                </button>
            </div>
            <div className="modal-body text-gray">
                <Card className="shadow">
                    <CardHeader className="border-0">
                        <Row className="align-items-center">
                            <div className="col">
                                <h3 className="mb-0">{commonStrings.feedback}
                                    <Badge
                                        className="ml-1"
                                        color="success">{feedbacks.length}</Badge>
                                </h3>
                            </div>
                        </Row>

                        <small><span className="mb-4">{commonStrings.feedback_expl}</span></small>
                    </CardHeader>
                    {feedbacks && feedbacks.length > 0 &&
                    (feedbacks.map((item, index) =>
                        <FeedbackItemRow
                            key={index}
                            item={item}
                        />))
                    }
                </Card>
            </div>
        </Modal>
    );

};

export default FeedbackComponent;